// 按照指定长度截取文字
export function limitWords(txt, num) {
  var str = txt;
  if (!str) return "";
  if (str.length > num) {
    return str.slice(0, num) + "...";
  }
  return str;
}

// 格式化带T的时间
export function timeFormat(date,seconds) {
  if (!date) {
    return new Date();
  }
  var dateString = new Date(date);
  function addZero(time) {
    return time < 10 ? `0${time}` : time;
  }
  let FormattedDateTime;
  if(seconds){
    FormattedDateTime = `${dateString.getFullYear()}/${
      addZero(dateString.getMonth() + 1)
    }/${addZero(dateString.getDate())} ${addZero(dateString.getHours())}:${addZero(dateString.getMinutes())}`;
  }else{
    FormattedDateTime = `${dateString.getFullYear()}/${
      addZero(dateString.getMonth() + 1)
    }/${addZero(dateString.getDate())} ${addZero(dateString.getHours())}:${addZero(dateString.getMinutes())}:${ addZero(dateString.getSeconds())}`;
  }
  return FormattedDateTime;
}

// 格式化带T的时间
export function timeFormatDate(date) {
  if (!date) {
    return '';
  }
  var dateString = new Date(date);
  function addZero(time) {
    return time < 10 ? `0${time}` : time;
  }
  let FormattedDateTime;
    FormattedDateTime = `${dateString.getFullYear()}年${
      addZero(dateString.getMonth() + 1)
    }月${addZero(dateString.getDate())}日`;
  return FormattedDateTime;
}


// 区分图片是base64/upload....
export function checkImg(val){
  if(val){
      return val.indexOf("data:image/")!=-1?val:`${this.$http.defaults.baseURL}/salary-service/open/showimg?path=${val}`
  }
}

